import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { formatTickerSymbolDisplay } from "../utility";
import { parseTickerSymbolStockInput } from "../orderDialogHelpers";

const defaultLabelProps = { shrink: true, sx: { fontWeight: 600 } };

/** Shared ticker Autocomplete (symbol + optional stock leg). */
const TickerSymbolAutocomplete = ({
  uniqueTickers,
  ticker,
  stock,
  setFormData,
  label = "Ticker",
  placeholder,
  required = true,
  inputLabelProps = defaultLabelProps,
}) => (
  <Autocomplete
    options={uniqueTickers}
    getOptionLabel={(option) =>
      typeof option === "string" ? option : formatTickerSymbolDisplay(option)
    }
    isOptionEqualToValue={(option, value) =>
      option.symbol === value.symbol &&
      (option.stock || "") === (value.stock || "")
    }
    value={
      uniqueTickers.find(
        (row) => row.symbol === ticker && (row.stock || "") === (stock || "")
      ) || null
    }
    onChange={(event, newValue) => {
      if (typeof newValue === "string") {
        setFormData((prev) => ({
          ...prev,
          ticker: newValue.toUpperCase(),
          stock: "",
        }));
        return;
      }
      setFormData((prev) => ({
        ...prev,
        ticker: newValue?.symbol || "",
        stock: newValue?.stock || "",
      }));
    }}
    freeSolo
    inputValue={formatTickerSymbolDisplay({ symbol: ticker, stock })}
    onInputChange={(event, newInputValue) => {
      const { symbol, stock: nextStock } =
        parseTickerSymbolStockInput(newInputValue);
      setFormData((prev) => ({
        ...prev,
        ticker: symbol,
        stock: nextStock,
      }));
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        variant="outlined"
        size="small"
        placeholder={placeholder}
        InputLabelProps={inputLabelProps}
        required={required}
      />
    )}
  />
);

export default TickerSymbolAutocomplete;
